import { gql } from "graphql-request";
import { TableSaversTableContent } from "types/graphql/generated";
import { TableBodyRow } from "./TableBodyRow";
import { TableHeadRow } from "./TableHeadRow";

interface Props {
  className?: string;
  content: TableSaversTableContent;
}

const Table = ({ content: { tableSaversElement, ...tableHeadRowContent }, className = "" }: Props) => {
  return (
    <div className={className}>
      <TableHeadRow content={tableHeadRowContent} className="Table__imagesContainer" />
      <ul className="Table__tableBody">
        {tableSaversElement.map((row) => {
          return <TableBodyRow content={row} className="Table__tableElement" key={row.id} />;
        })}
      </ul>
    </div>
  );
};

gql`
  fragment TableSaversTableContent on ComponentTableTableSavers {
    ...TableSaversTableHeadRowContent
    tableSaversElement {
      ...TableSaversBodyRowFragment
    }
  }
`;

export { Table };
